module.exports = __webpack_public_path__ + "static/img/yonda.f4be470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/yonda.png
// module id = lY5p
// module chunks = 34